import { render, staticRenderFns } from "./adminLoop.vue?vue&type=template&id=c15adef8&scoped=true"
import script from "./adminLoop.vue?vue&type=script&lang=js"
export * from "./adminLoop.vue?vue&type=script&lang=js"
import style0 from "./adminLoop.vue?vue&type=style&index=0&id=c15adef8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c15adef8",
  null
  
)

export default component.exports